var _g, _path, _circle, _circle2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 141,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M83.8 136.382c32.032 0 57.999-25.967 57.999-58 0-32.032-25.967-58-58-58-32.032 0-58 25.968-58 58 0 32.033 25.968 58 58 58Z",
    fill: "#E3EFF7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.5,
    cy: 79,
    r: 41,
    fill: "#74B0D7"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M92.947 62.042H77.052c-5.538 0-9.01 3.921-9.01 9.471v14.975c0 5.55 3.455 9.47 9.01 9.47h15.892c5.556 0 9.014-3.92 9.014-9.47V71.513c0-5.55-3.458-9.471-9.013-9.471Z",
    stroke: "#F8F9FC",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.14 82.258.108-2.66a5.404 5.404 0 0 0 1.673-.792 5.232 5.232 0 0 0 1.684-1.97c.398-.8.595-1.691.595-2.671 0-1.035-.214-1.957-.647-2.76a4.752 4.752 0 0 0-1.82-1.918c-.767-.46-1.668-.687-2.696-.687-1.183 0-2.236.303-3.152.912a5.71 5.71 0 0 0-1.758 1.822c-.25.408-.138.915.193 1.225.524.488 1.332.304 1.738-.215.238-.306.507-.573.806-.802.576-.428 1.272-.646 2.099-.646.635 0 1.17.14 1.616.41.45.273.789.647 1.022 1.125l.002.005c.25.481.377 1.026.377 1.639 0 .631-.128 1.195-.378 1.696-.251.5-.603.905-1.056 1.215-.43.287-.94.442-1.537.46a.82.82 0 0 0-.817.825l.018 3.752a.965.965 0 0 0 1.93.035Zm-2.152 6.405c.302.354.69.537 1.15.537.472 0 .869-.18 1.174-.537.298-.349.447-.762.447-1.229 0-.498-.146-.923-.45-1.258a1.483 1.483 0 0 0-1.172-.535c-.458 0-.845.181-1.147.534-.304.336-.45.76-.45 1.26 0 .466.15.88.448 1.228Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.093 141.277c-9.21 0-18.377-2.058-26.934-6.144-15.09-7.206-26.47-19.858-32.046-35.625-5.574-15.766-4.675-32.759 2.531-47.85 7.206-15.09 19.858-26.47 35.624-32.045 15.765-5.574 32.759-4.675 47.849 2.531 7.125 3.403 13.445 8.028 18.787 13.75a.288.288 0 1 1-.422.392c-5.291-5.67-11.553-10.252-18.613-13.623-30.864-14.739-67.966-1.621-82.706 29.243-14.74 30.865-1.621 67.967 29.243 82.707 14.952 7.14 31.789 8.031 47.41 2.508 15.621-5.523 28.157-16.8 35.297-31.751 3.25-6.807 5.219-14.035 5.849-21.483a.284.284 0 0 1 .311-.262.287.287 0 0 1 .262.31 62.362 62.362 0 0 1-5.904 21.683c-7.206 15.091-19.859 26.472-35.624 32.046-6.825 2.412-13.882 3.613-20.914 3.613Z",
    fill: "#323232"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.84 29.803c-.258-1.07-1.782-1.07-2.04 0l-.335 1.388a1.05 1.05 0 0 1-.774.774l-1.388.335c-1.071.259-1.071 1.782 0 2.04l1.388.336c.383.092.681.391.774.774l.335 1.387c.258 1.072 1.782 1.072 2.04 0l.336-1.387a1.05 1.05 0 0 1 .774-.774l1.387-.335c1.071-.259 1.071-1.782 0-2.041l-1.387-.335a1.05 1.05 0 0 1-.774-.774l-.335-1.388ZM148.841 109.803c-.259-1.071-1.783-1.071-2.041 0l-.335 1.388a1.05 1.05 0 0 1-.774.774l-1.388.335c-1.071.259-1.071 1.782 0 2.041l1.388.335c.383.092.681.391.774.774l.335 1.387c.258 1.072 1.782 1.072 2.041 0l.335-1.387c.092-.383.391-.682.774-.774l1.387-.335c1.071-.259 1.071-1.782 0-2.041l-1.387-.335a1.048 1.048 0 0 1-.774-.774l-.335-1.388Z",
    fill: "#323232"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.498,
    cy: 16.998,
    r: 2.498,
    stroke: "#323232"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 141.498,
    cy: 128.998,
    r: 2.998,
    fill: "#74B0D7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h159v141H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.0f61dcb0b5f9c79b7ce0f70386f366ef.svg";
export { ForwardRef as ReactComponent };